const benefits = [
  {
    icon: "ri-shield-check-line",
    title: "Discrição e Sigilo Total",
    description:
      "Todos os atendimentos são realizados com absoluta privacidade. Sua identidade e preferências são preservadas com total sigilo.",
  },
  {
    icon: "ri-spa-line",
    title: "Diversas Opções de Massagem",
    description:
      "Massagem relaxante, terapêutica, tântrica, shiatsu e muito mais. Encontre o serviço ideal para suas necessidades em Curitiba.",
  },
  {
    icon: "ri-map-pin-2-line",
    title: "Profissionais em Toda Curitiba",
    description:
      "Massagistas nos principais bairros de Curitiba e região metropolitana: Batel, Centro, Água Verde, Rebouças, Portão e muito mais.",
  },
  {
    icon: "ri-calendar-check-line",
    title: "Agendamento Rápido e Direto",
    description:
      "Entre em contato diretamente com a profissional de sua escolha. Agendamento simples, rápido e sem intermediários.",
  },
  {
    icon: "ri-medal-line",
    title: "Profissionais Verificadas",
    description:
      "Todas as massagistas passam por um processo de verificação para garantir qualidade, autenticidade e segurança no atendimento.",
  },
  {
    icon: "ri-heart-pulse-line",
    title: "Bem-Estar Garantido",
    description:
      "Foco total no seu relaxamento e bem-estar. Profissionais capacitadas para proporcionar a melhor experiência de massagem em Curitiba.",
  },
];

export default function Benefits() {
  return (
    <section id="beneficios" className="py-20 md:py-28 bg-stone-50">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <span className="text-rose-400 text-sm font-semibold tracking-widest uppercase mb-3 block">Por que nos escolher</span>
          <h2 className="text-3xl md:text-4xl font-bold text-stone-800 mb-4" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            Atendimento de Qualidade em Curitiba
          </h2>
          <p className="text-stone-500 max-w-xl mx-auto text-base leading-relaxed">
            Conectamos você às melhores massagistas de Curitiba com foco em conforto, privacidade e bem-estar.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {benefits.map((b, i) => (
            <div
              key={i}
              className="bg-white rounded-2xl p-7 border border-stone-100 hover:border-rose-200 transition-all duration-300 hover:-translate-y-1 group"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-rose-50 rounded-xl mb-5 group-hover:bg-rose-100 transition-colors">
                <i className={`${b.icon} text-2xl text-rose-400`}></i>
              </div>
              <h3 className="text-lg font-semibold text-stone-800 mb-2">{b.title}</h3>
              <p className="text-stone-500 text-sm leading-relaxed">{b.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
